<script>
import { mapGetters } from 'vuex';
export default {
  name: 'EventHeaderIconBoxMobile',
  props: {
    iconType: {
      type: String,
      required: true,
      validator: function(value) {
        return ['eventCondition', 'prizeMoney', 'trackDistance', 'trackCondition', 'moreModal'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    ...mapGetters({
      isMoreInfoModalActive: 'FormGuideEventHeader/isMoreInfoModalActive',
      eventData: 'FormGuideEventHeader/getEventData',
      entryClass: 'FormGuideEventHeader/getEntryClass',
      totalPrizeMoney: 'FormGuideEventHeader/getTotalPrizeMoney',
    }),
    isEventCondition() {
      return this.iconType === 'eventCondition';
    },
    isPrizeMoney() {
      return this.iconType === 'prizeMoney';
    },
    isTrackDistance() {
      return this.iconType === 'trackDistance';
    },
    isTrackCondition() {
      return this.iconType === 'trackCondition';
    },
    isMoreModal() {
      return this.iconType === 'moreModal';
    },
    getUnitDistance() {
      const { eventData } = this;
      if (eventData) {
        const unit = eventData.distance_unit == 'meter' ? 'm' : '';
        return `${eventData.distance}${unit}`;
      }
      return '';
    },
    titleText() {
      const {
        isEventCondition,
        isPrizeMoney,
        isTrackDistance,
        isTrackCondition,
        isMoreModal,
        entryClass,
        totalPrizeMoney,
        getUnitDistance,
      } = this;

      if (isEventCondition) return `${entryClass}`;
      if (isPrizeMoney) return `$${totalPrizeMoney}`;
      if (isTrackDistance) return `${getUnitDistance}`;
      if (isTrackCondition) return `Good`;
      if (isMoreModal) return `More`;
    },
    iconClassName() {
      const { iconType } = this;
      const classNameMap = {
        eventCondition: 'event-condition',
        prizeMoney: 'prize-money',
        trackDistance: 'track-dist',
        trackCondition: 'track-condition',
        moreModal: 'more-icon',
      };
      return classNameMap[iconType];
    },
  },
  methods: {
    // toggle more information modal
    toggleModal() {
      const { isMoreModal, eventData } = this;
      if (isMoreModal) {
        this.$store.dispatch('FormGuideEventHeader/toggleMoreInfoModal');
        history.pushState({ eventId: eventData.id }, '');
      }
    },
  },
};
</script>

<template>
  <div class="event-header-icon-box" @click.prevent="toggleModal">
    <div class="event-header-icon-box__container">
      <div :class="`${iconClassName} event-header-icon-box__icon`"></div>
      <div class="event-header-icon-box__text">{{ titleText }}</div>
      <div class="event-header-icon-box__details"></div>
    </div>
  </div>
</template>
